import Zepto from 'zepto-webpack'
import appLoader from '@/common/loader/app'

/** COMPONENTS */
import KryptonBrandButtons from '@/host/components/controls/KryptonBrandButtons'

export default locator => {
  return ({ brandButtonsId }) => {
    const el = `.kr-brand-buttons-wrapper[kr-brand-buttons-id="${brandButtonsId}"]`
    // Brand buttons rely on the card form context (BrandMixin injects it). When
    // rendered outside .kr-embedded they get their own app, so provide the
    // default card form context here or context.namespace would be undefined.
    const formId = locator.$store.state.forms.default
    return appLoader(locator, Zepto(el), {
      el,
      provide: {
        context: { formId, namespace: `cardForm_${formId}` }
      },
      components: { KryptonBrandButtons }
    })
  }
}
